import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import colors from '../../../config/colors';

interface FormSectionProps {
  number: number;
  title: string;
  description: string;
  children: React.ReactNode;
}

export const FormSection: React.FC<FormSectionProps> = ({ number, title, description, children }) => (
  <Paper
    elevation={0}
    sx={{ mb: 3, border: `1px solid ${colors.grayLight}`, borderRadius: 2, overflow: 'hidden' }}
  >
    <Grid container>
      <Grid
        item
        xs={12}
        md={4}
        sx={{
          bgcolor: colors.grayUltraLight,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          borderRight: { md: `1px solid ${colors.grayLight}` },
        }}
      >
        <Typography
          variant='subtitle2'
          sx={{ color: colors.primary, fontWeight: 'bold', fontFamily: 'Montserrat', mb: 0.5 }}
        >
          SECCIÓN {number}
        </Typography>
        <Typography variant='h6' sx={{ fontWeight: 'bold', fontFamily: 'Montserrat', color: colors.gray, mb: 1 }}>
          {title}
        </Typography>
        <Typography variant='body2' sx={{ color: colors.grayLight, fontFamily: 'Montserrat' }}>
          {description}
        </Typography>
      </Grid>
      <Grid item xs={12} md={8} sx={{ p: 3 }}>
        {children}
      </Grid>
    </Grid>
  </Paper>
);
